import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthGuard} from './core/services/auth-guard.service';
import {ActivateComponent} from './routed/landing/components/activate/activate.component';
import {UnauthorizedComponent} from './routed/landing/components/unauhtorized/unauthorized.component';
import {SocialAuth2Component} from "./routed/landing/components/social-auth/social-auth-2.component";

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./routed/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'agreements',
    loadChildren: () => import('./feature/agreements/agreements.module').then(m => m.AgreementsModule),
  },
  {
    path: 'control-panel',
    canLoad: [AuthGuard],
    loadChildren: () => import('./routed/control-panel/control-panel.module').then(m => m.ControlPanelModule),
  },
  {
    path: 'settings',
    canLoad: [AuthGuard],
    loadChildren: () => import('./routed/settings/settings.module').then(m => m.SettingsModule),
  },
  {
    path: 'payments',
    canLoad: [AuthGuard],
    loadChildren: () => import('./routed/payments/payments.module').then(m => m.PaymentsModule),
  },
  {
    path: 'donate',
    loadChildren: () => import('./routed/order-panel/order-panel.module').then(m => m.OrderPanelModule),
  },
  {
    path: 'activate',
    component: ActivateComponent,
  },
  {
    path: 'social-auth',
    component: SocialAuth2Component,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes, {
    onSameUrlNavigation: 'reload'
}
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
